import Vue from 'vue'
import Vuex from 'vuex'
import files from './store/modules/files'
import locations from './store/modules/locations'
import sliders from './store/modules/sliders'
import user from './store/modules/user'
import orders from './store/modules/orders'
import reports from './store/modules/reports'
import mop from './store/modules/mop'

import { Api } from '@/core/api.js'
const api = new Api()

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: {
    menu_is_visible: true,
    usermenu_is_visible: false,
    locationsmenu_is_visible: false,
    language: 'CAST',
    languages: [],
    title: process.env.VUE_APP_MARKET == 'ES' ? 'LSM' : 'LRM',
    app_url: 'http://localhost:8080/#/',
    search: '',
    is_loading: false,
    table_relatioship: false,
    show_uploads: true,
    market: ''
  },
  modules: {
    files,
    locations,
    sliders,
    user,
    orders,
    reports,
    mop
  },
  strict: debug,
  mutations: {
    setMenuVisible (state, value) {
      state.menu_is_visible = value
    },

    setOverlayVisible (state, value) {
      state.overlay_is_visible = value
    },

    setUserMenuVisible (state, value) {
      state.usermenu_is_visible = value
    },

    setLocationsMenuVisible (state, value) {
      state.locationsmenu_is_visible = value
    },

    setTitle (state, value) {
      state.title = value
    },

    setSearch (state, value) {
      state.search = value
    },

    setLoading (state, value) {
      state.is_loading = value
    },

    setLanguage (state, value) {
      for (var k in state.languages) {
        if (state.languages[k].name === value) {
          state.languages[k].selected = true;
        } else {
          state.languages[k].selected = false;
        }
      }
      state.language = value;
      if (state.market === 'PT' && value === 'PT') {
        localStorage.language = value;
      } else if (state.market === 'ES' && (value === 'CAST' || value === 'CAT')) {
        localStorage.language = value;
      }
    },

    setTables (state, tables) {
      if (typeof tables['language'] !== 'undefined') {
        state.languages = tables['language'];
        const currentLang = state.language;
        for (var key in state.languages) {
          state.languages[key].selected = state.languages[key].name === currentLang;
        }
      }
      if (typeof tables['resource_type'] !== 'undefined') {
        state.files.resources_type = tables['resource_type']
      }
      if (typeof tables['restaurant_type'] !== 'undefined') {
        state.locations.types = tables['restaurant_type']
      }
      if (typeof tables['restaurant_region'] !== 'undefined') {
        state.locations.regions = tables['restaurant_region']
      }
      if (typeof tables['province'] !== 'undefined') {
        state.locations.provinces = tables['province']
      }
      if (typeof tables['order_status'] !== 'undefined') {
        state.orders.status = tables['order_status']
      }

      state.table_relatioship = true
    },

    cleanPagesSelected (state) {
      state.files.current_file = false
      state.files.uploading = false
      state.file.pullUploads = []

      state.locations.selected = {}
      state.locations.restaurant = false

      state.orders.current_order = false

      state.user.current_user = false
    },

    showUploads (state, value) {
      state.show_uploads = value
    },

    setMarket (state, value) {
      state.market = value
    }
  },
  actions: {
    loadTablesRelationship: ({ commit }) => {
      return api.get('table').then(function (data) {
        if (data.status) {
          return commit('setTables', data.data)
        }
      })
    },

    loadUser ({ commit, dispatch }) {
      return api.getSession().then(function (data) {
        dispatch('loadTablesRelationship')
        if (data.status) {
          var n = 0
          var current = localStorage.site ? localStorage.site : false

          for (const key in data.data.restaurants) {
            if (data.data.restaurants.hasOwnProperty(key)) {
              data.data.restaurants[key].available = true

              if (current == data.data.restaurants[key].site) {
                data.data.restaurants[key].selected = true
                n = key
              } else {
                data.data.restaurants[key].selected = n == 0
                if (n == 0) n = key
              }
            }
          }

          if (data.data.sliders) { commit('sliders/setSliders', data.data.sliders) }
          if (data.data.restaurants) { commit('locations/setLocations', data.data.restaurants) }
          if (data.data.restaurants) { commit('locations/setSelectedLocation', data.data.restaurants[n]) }
          return commit('user/setAuthenticate', data.data)
        } else if (data.error == 403) {
          commit('user/logoutUser')
          return commit('user/setAuthenticate', false)
        }
      })
    },

    logout ({ commit }) {
      commit('locations/setLocations', [])
      commit('user/logoutUser')
    },

    loadMarket: ({ commit, state }) => {
      return api.get('market').then(function (data) {
        if (data.status) {
          commit('setMarket', data.data);
          const initialLang = data.data === 'PT' ? 'PT' : 'CAST';
          commit('setLanguage', initialLang);
        }
      })
    },
  },
  getters: {
    getLanguages: (state, getter, rootState) => {
      return state.languages
    },

    uploads_show: (state, getter, rootState) => {
      return state.show_uploads
    },

    getMarket: (state, getter, rootState) => {
      return state.market
    }
  }
})
